import { APIGetRequest, APIPostRequest } from "@/utils/requests";
import {
  FeatureAnnouncement,
  FeatureAnnouncementUserVisit,
} from "../models/feature-announcements";

/**
 * Get a feature announcement by its slug
 */
export async function getFeatureAnnouncementBySlug(
  slug: string
): Promise<FeatureAnnouncement | null> {
  try {
    const response = await APIGetRequest<{
      data: FeatureAnnouncement;
    }>(`/api/v2/user/feature-announcements/${slug}`);
    return response.data;
  } catch (error) {
    // APIGetRequest throws on non-ok responses, check if it's a 404
    if (error instanceof Error && error.message.includes("(404)")) {
      return null;
    }
    throw error;
  }
}

/**
 * Get all feature announcement visits for the current user
 * Returns empty array if user is not authenticated
 */
export async function getFeatureAnnouncementVisitsForUser(): Promise<
  FeatureAnnouncementUserVisit[]
> {
  const response = await APIGetRequest<{
    data: FeatureAnnouncementUserVisit[];
  }>("/api/v2/user/feature-announcements/visits");
  return response.data;
}

/**
 * Create a new feature announcement user visit record
 */
export async function createFeatureAnnouncementUserVisit(
  featureAnnouncementId: string
): Promise<FeatureAnnouncementUserVisit | null> {
  const response = await APIPostRequest<{
    data: FeatureAnnouncementUserVisit;
  }>("/api/v2/user/feature-announcements/visits", {
    feature_announcement_id: featureAnnouncementId,
  });
  return response.data;
}
